export default function AccessSection() {
  const infoItems = [
    {
      label: '住所',
      content: (
        <>
          〒930-0083<br />
          富山県富山市総曲輪<br />
          １丁目３−９ グリーンビル２F
        </>
      ),
    },
    {
      label: 'エリア',
      content: '桜木町エリア',
    },
    {
      label: '営業時間',
      content: (
        <>
          21:00～ラスト　※お問い合わせください。<br />
          定休日　日曜日（変更あり）
        </>
      ),
    },
  ];

  return (
    <section id="info" className="w-full py-20 md:py-28" style={{ background: '#fff' }}>
      <div className="max-w-4xl mx-auto px-6">

        {/* Section heading */}
        <div className="text-center mb-14">
          <p
            className="text-xs tracking-[0.35em] mb-3"
            style={{ color: '#AAC4DC', fontFamily: "'Noto Serif JP', serif" }}
          >
            INFORMATION
          </p>
          <h2
            className="text-2xl md:text-3xl font-medium tracking-[0.2em]"
            style={{ fontFamily: "'Noto Serif JP', serif", color: '#2a2a2a' }}
          >
            基本情報
          </h2>
          <div className="flex items-center justify-center gap-3 mt-5">
            <div className="h-px w-16" style={{ background: '#AAC4DC' }} />
            <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#AAC4DC' }} />
            <div className="h-px w-16" style={{ background: '#AAC4DC' }} />
          </div>
        </div>

        {/* Lead text */}
        <p
          className="text-sm md:text-base leading-loose tracking-wide text-center mb-10 whitespace-pre-line"
          style={{ color: '#666', fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          {'桜木町エリア\nアミューズメント要素も充実で\n団体様からおひとり様もお気軽にお立ち寄りください♪'}
        </p>

        {/* Info card */}
        <div
          className="rounded-xl overflow-hidden mb-8"
          style={{ border: '1px solid rgba(170,196,220,0.3)' }}
        >
          {infoItems.map((item, i) => (
            <div
              key={item.label}
              className="px-6 py-5"
              style={{
                borderBottom: i < infoItems.length - 1 ? '1px solid rgba(170,196,220,0.2)' : 'none',
                background: i % 2 === 0 ? '#fff' : 'rgba(170,196,220,0.04)',
              }}
            >
              <p
                className="text-xs tracking-widest mb-2"
                style={{ color: '#AAC4DC', fontFamily: "'Noto Serif JP', serif" }}
              >
                {item.label}
              </p>
              <p className="text-sm text-gray-700 leading-relaxed tracking-wide">
                {item.content}
              </p>
            </div>
          ))}
        </div>

        {/* Google Map */}
        <div className="rounded-xl overflow-hidden mb-6" style={{ border: '1px solid rgba(170,196,220,0.25)' }}>
          <iframe
            title="Girls Bar Uru アクセスマップ"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3215.0!2d137.2126!3d36.6953!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5ff7914b9e3b1f1f%3A0x1234567890abcdef!2z5a-M5bGx55yM5a-M5bGx5biC57eP5puy6LuK77yR5LiB55uu77yT4oiS77yZ44Kw44Oq44O844Oz44OT44Or77yS!5e0!3m2!1sja!2sjp!4v1700000000000!5m2!1sja!2sjp"
            width="100%"
            height="320"
            style={{ border: 0, display: 'block' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* CTA */}
        <a
          href="https://maps.google.com/?q=富山県富山市総曲輪1丁目3-9+グリーンビル2F"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 py-3.5 rounded-xl text-sm tracking-widest font-medium transition-opacity hover:opacity-80 cursor-pointer whitespace-nowrap"
          style={{ background: 'linear-gradient(135deg, #AAC4DC 0%, #8fb3d0 100%)', color: '#fff', fontFamily: "'Noto Serif JP', serif" }}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-map-2-line text-sm" />
          </div>
          Google マップで開く
        </a>
      </div>
    </section>
  );
}
